// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"7708bfe3","488":"ed327f1f","591":"c2c6cfbb","900":"f79583f7"}[chunkId] + ".chunk.js";
};